module.exports = __webpack_public_path__ + "img/chevron-down.1588170d.svg";